import { logError, logState } from 'common/utils/errors'
import { omit } from 'common/utils/objectUtils'

export const catchError = (error) => (dispatch, getState) => {
  const state =  omit(getState(), 'searchResponses')
  logState(state)
  logError(error)
}
